<form id="payment-form">
  <div id="card-container" style="margin-top: 0">
    <div id="credit-card"></div>
  </div>

  <button id="card-button" type="button">Store Card</button>
</form>
<div id="payment-status-container" class="store-card-message"></div>